import { useContext } from "react";

import { SnackbarContext } from "./GlobalSnackbarProvider";

export default function useSnackbar() {
  const { snackbar } = useContext(SnackbarContext);
  return snackbar;
}
